import { RecoilRoot } from "recoil";
import "./src/styles/global.css";
import React from "react";
import Layout from "./src/components/layout";

export const wrapPageElement = ({ element }) => {
  return (
    <RecoilRoot>
      <Layout>{element}</Layout>
    </RecoilRoot>
  );
};
